<template>
  <div>
    <va-modal
      title="Devis validé"
      class="modal"
      v-model="showModal"
      max-width="100%"
      :hideDefaultActions="true"
      v-on:cancel="closeModal"
    >
      <div class="row customsize">
        <div class="flex md6 setheight">
          <div
            class="row"
            v-if="showUpload || fileUploaded"
          >
            <div
              class="flex md12"
              v-show="showUpload || fileUploaded"
            >
              <va-button
                class="fullwidth"
                :disabled="!fileUploaded"
                outline
                color="info"
                @click="uploadDevisPdf"
              >Téléverser le devis d'adhésion</va-button>
            </div>
            <div
              class="flex md6"
              v-show="showUpload"
            >
              <va-button
                class="fullwidth"
                outline
                color="info"
                @click="approveDevis"
              >Approuvé sans retour signature</va-button>
            </div>

            <div
              class="flex md6 px-3"
              v-show="showUpload"
            >
              <va-date-picker
                :config="{ dateFormat: 'd-m-Y' }"
                label="Date de validation"
                v-model="setDateDevis"
              >Annuler</va-date-picker>
            </div>
            <div class="flex md6">
              <va-button
                v-show="fileUploaded || changeFile"
                class="fullwidth"
                outline
                color="info"
                @click="
                  file = [];
                  changeFile = false;
                "
              >Annuler</va-button>
            </div>
            <div class="flex md6 px-3">
              <va-date-picker
                v-show="fileUploaded || changeFile"
                :config="{ dateFormat: 'd-m-Y' }"
                label="Date de validation"
                v-model="setDateDevis"
              >Annuler</va-date-picker>
            </div>
          </div>
          <div
            class="row"
            v-if="devisValidationSelected && !showUpload && !changeFile"
          >
            <div class="flex md12">
              <va-button
                v-show="hasRealPdf"
                class="fullwidth"
                outline
                color="info"
                @click="displayDevisPdf(devisValidationSelected)"
              >Visualiser</va-button>
            </div>
            <div class="flex md12">
              <va-button
                v-show="hasRealPdf"
                class="fullwidth"
                outline
                color="info"
                @click="downloadDevisPdf(devisValidationSelected)"
              >Télécharger</va-button>
            </div>

            <div class="flex md12">
              <va-button
                class="fullwidth"
                outline
                color="info"
                @click="changeFile = true"
              >Modifier</va-button>
            </div>
            <div class="flex md12">
              <va-button
                class="fullwidth"
                outline
                color="danger"
                @click="dissociateDevis()"
              >Dissocier</va-button>
            </div>
            <div
              class="flex md12"
              v-if="false"
            >
              <va-button
                class="fullwidth"
                outline
                color="danger"
                @click="deleteDevisPdf"
              >Supprimer
              </va-button>
            </div>
          </div>

          <div class="flex md12 mt-5 fullsize">
            <h4
              class="fullwidth mb-3"
              style="position: relative; top: 0.5em"
            >
              Historique:
            </h4>
            <div
              class="row"
              v-if="listPDF.length < 1"
            >
              <div class="flex md12 mt-3">
                <p class="text--secondary">Aucun PDF disponible</p>
              </div>
            </div>
            <div
              class="row actions-container"
              v-if="listPDF.length > 0"
            >
              <div class="flex md12 px-2">
                <div class="row pb-2 px-2">
                  <div class="flex md2">Validation</div>
                  <div class="flex md3">Téléversement</div>
                  <div class="flex md4">Utilisateur</div>
                  <div class="flex md3"></div>
                </div>
                <template v-for="pdf in listPDF">
                  <div class="row pb-2 px-2">
                    <div class="flex md2 text-lighter">
                      <b>{{ convertDate(pdf.date_validation) }}</b>
                    </div>
                    <div class="flex md3 text-lighter">
                      <b>{{ convertDate(pdf.date_upload) }}</b>
                    </div>
                    <div class="flex md4 text-lighter">
                      <b>{{ pdf.utilisateur }}</b>
                    </div>
                    <div class="flex md3 text-lighter pa-0 ma-0">
                      <div class="row row-inside">
                        <div class="flex md4 offset-up">
                          <va-button
                            flat
                            v-show="pdf.iddevis_pdf_validations !== pdf.iddevis"
                            color="info"
                            icon="fa fa-eye"
                            @click="
                              displayDevisPdf(pdf.iddevis_pdf_validations)
                            "
                          />
                        </div>
                        <div class="flex md4 offset-up">
                          <va-button
                            flat
                            v-show="pdf.iddevis_pdf_validations !== pdf.iddevis"
                            color="info"
                            icon="fa fa-download"
                            @click="
                              downloadDevisPdf(pdf.iddevis_pdf_validations)
                            "
                          />
                        </div>
                        <div class="flex md4 offset-up">
                          <va-button
                            flat
                            :color="
                              pdf.iddevis_pdf_validations ===
                              devisValidationSelected
                                ? 'success'
                                : 'info'
                            "
                            icon="fa fa-check"
                            @click="associateDevis(pdf.iddevis_pdf_validations)"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
        <div class="flex md6 px-3">
          <va-file-upload
            type="single"
            dropzone
            file-types=".pdf"
            v-model="file"
            color="info"
            v-show="showUpload"
          />
          <iframe
            id="iframeDevisPdf"
            ref="iframeDevisPdf"
            v-if="fileUploaded || pdfurl"
            class="fullsize fullsize-marging"
            :src="pdfSrc"
          />
          <div
            class="solid fullsize"
            v-if="devisValidationSelected && !pdfurl &&  hasRealPdf"
          >
            <va-icon
              class="center-icon"
              name="fa fa-eye"
              color="info"
              size="5em"
            />
          </div>
          <div
            class="solid fullsize"
            v-if="devisValidationSelected && !pdfurl &&  !hasRealPdf"
          >
            <h1 class="center-icon"> Signature non disponible </h1>

          </div>

        </div>
      </div>
    </va-modal>
  </div>
</template>

    <script>
import axios from "axios";
import moment from "moment";
import { find } from "lodash";

export default {
  name: "DevisValideManager",
  props: ["value", "iddevis", "entrepriseName"],
  data() {
    return {
      setDateDevis: moment().format("DD-MM-YYYY"),
      listPDF: [],
      devisValidationSelected: false,
      showModal: false,
      file: [],
      changeFile: false,
      pdfurl: null,
      actions: [],
      actionsType: ["téléversé", "remplacé", "supprimé"],
      //TODO a preciser
      isAdmin:
        this.$store.getters.user.droits &&
        this.$store.getters.user.droits === "ADMIN",
    };
  },
  computed: {
    pdfSrc() {
      if (this.file.length > 0) {
        let url = URL.createObjectURL(this.file[0]);
        return url;
      } else if (this.pdfurl) {
        return this.pdfurl;
      } else {
        return "";
      }
    },
    fileUploaded() {
      return this.file.length > 0 ? true : false;
    },
    hasRealPdf() {
      if (this.devisValidationSelected) {
        let devispdf = find(this.listPDF, { iddevis_pdf_validations: this.devisValidationSelected })
        if (devispdf.iddevis_pdf_validations === devispdf.iddevis) {
          return false
        } else {
          return true
        }
      }
      return false

    },
    showUpload() {
      return (
        (this.changeFile || !this.devisValidationSelected) && !this.fileUploaded
      );
    },
  },
  watch: {
    changeFile(newValue) {
      if (newValue) {
        this.setDateDevis = moment().format("DD-MM-YYYY");
      }
    },
    value() {
      this.showModal = this.value;
      // Parent property changed; update internal variables
      if (!this.value) {
        this.resetComponent();
      } else if (!this.iddevis) {
        console.log("no devis selected");
      } else {
        this.loadDevisPdfList(this.iddevis);
      }
    },
  },
  methods: {
    // TODO disable buttons as they are treating the demand
    // TODO deal with errors
    async associateDevis(idDevisPdf) {
      try {
        let params = {
          iddevis: this.iddevis,
          idDevisPdf: idDevisPdf,
        };
        await axios.put("/api/publications-web/associate-devis-valide", params);

        this.loadDevisPdfList(this.iddevis);
        this.$emit("update");
      } catch (error) {
        console.log(error);
        this.launchEpicmaxToast("Erreur lors de l'association");
      }
    },
    async dissociateDevis() {
      try {
        let params = {
          iddevis: this.iddevis,
        };
        await axios.put("/api/publications-web/dissociate-devis-valide", params);

        this.loadDevisPdfList(this.iddevis);
        this.$emit("update");

      } catch (error) {
        console.log(error);
        this.launchEpicmaxToast("Erreur lors de la dissociation");
      }
    },
    async deleteDevisPdf(idDevisPdf) {
      try {
        await axios.delete("api/publications-web/devis-valide", {
          params: { idDevisPdf: idDevisPdf },
        });
        //TODO deal with deletion
        //this.resetComponent();
        //this.$emit("deleted");
        this.$emit("update");
      } catch (err) {
        // TODO deal with error
        console.log(err);
        this.launchEpicmaxToast("Erreur lors de la suppression");
      }
    },

    async downloadDevisPdf(idDevisPdf) {
      try {
        if (!idDevisPdf) {
          return;
        }

        let url = await this.getDevisPdfURL(idDevisPdf);

        let response = await axios.get(url, { responseType: "blob" });
        const blob = new Blob([response.data], {
          type: "application/pdf",
        });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "Devis_validé_" + this.entrepriseName;
        link.click();
        URL.revokeObjectURL(link.href);
      } catch (err) {
        // TODO deal with error
        console.log(err);
        this.launchEpicmaxToast("Erreur lors du téléchargement");
      }
    },
    async getDevisPdfURL(idDevisPdf) {
      try {
        let resp = await axios.get("api/publications-web/pdf-devis-valide", {
          params: { idDevisPdf: idDevisPdf },
        });
        return resp.data;
      } catch (err) {
        //TODO manage error
        this.launchEpicmaxToast("Erreur lors de la recherche du DevisPdf");

        throw "no pdf";
      }
    },
    async displayDevisPdf(idDevisPdf) {
      if (idDevisPdf) {
        this.pdfurl = await this.getDevisPdfURL(idDevisPdf);
      }
    },

    resetComponent() {
      this.file = [];
      this.changeFile = false;
      this.pdfurl = null;
      this.setDateDevis = moment().format("DD-MM-YYYY");
    },
    async loadDevisPdfList(iddevis) {
      try {
        //import liste devis
        let res = await axios.get("api/publications-web/liste-devis-valide", {
          params: {
            iddevis: iddevis,
          },
        });

        console.log(res.data);
        if (res.data.devisValidationSelected) {
          this.devisValidationSelected = res.data.devisValidationSelected;
        } else {
          this.devisValidationSelected = null;
        }
        this.listPDF = res.data.listPDF;
        this.resetComponent();
      } catch (error) {
        //manage errors
        console.log(error);
        this.launchEpicmaxToast(
          "Impossible de charger les informations des devis signés"
        );
      }
    },
    closeModal() {
      this.resetComponent();
      this.$emit("input", false);
    },
    async approveDevis() {
      try {
        await axios.post("/api/publications-web/devis-valide-nopdf", {
          iddevis: this.iddevis,
          dateValidation: this.setDateDevis,
        });
        this.$emit("update");
        this.loadDevisPdfList(this.iddevis);
      } catch (error) {
        this.launchEpicmaxToast("Erreur lors de l'envoi du Devis");
      }
    },
    async uploadDevisPdf() {
      // TODO DEAL WITH ERROR
      //check that file exist then upload to server
      try {
        if (this.file.length > 0 && this.iddevis) {
          let formData = new FormData();
          formData.append("devisPdf", this.file[0]);
          await axios.post("/api/publications-web/devis-valide", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            params: {
              iddevis: this.iddevis,
              dateValidation: this.setDateDevis,
            },
          });
          this.$emit("update");
          this.loadDevisPdfList(this.iddevis);
        }
      } catch (error) {
        this.launchEpicmaxToast("Erreur lors de l'envoi du DevisPdf");
      }
    },
    convertDate(date) {
      // TODO : move to support functions
      let t = date.split("-");
      return t[2] + "-" + t[1] + "-" + t[0];
    },
    launchEpicmaxToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000,
      });
    },
  },
};
</script>

<style scoped>
.customsize {
  width: 60vw;
  height: 60vh;
  overflow: auto;
}
.fullwidth {
  width: 95%;
}

.solid {
  border: 2px solid #4ab2e3;
  border-radius: 25px;
  position: relative;
}

.fullsize {
  width: 100%;
  height: 90%;
}
.fullsize-marging {
  margin-top: 25px;
}

.center-icon {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.text-lighter {
  color: #b2b2b2;
}

.actions-container {
  overflow: auto;
  height: 100%;
  direction: ltr;
}

.setheight {
  height: 60%;
}

.offset-up {
  position: relative;
  top: -0.5em;
}
</style>
